import { Lock } from '@phosphor-icons/react';
import { Control, FieldErrors, UseFormHandleSubmit } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import PartfinitiLogo from 'assets/partfinitiLogo.svg';
import { IAuthUser, IAuthForm } from 'auth/types';
import { InputType } from 'core/enums';
import { FormField } from 'core/components';
import { enterPress, getDomainUrl } from 'core/utils';
import { Level, Size, Variant } from 'theme/enums';

import {
  Image,
  LeftSide,
  LeftSideContent,
  Logo,
  LogoImage,
  PageGrid,
  RightSide,
  SsoButton,
  TitleSignIn,
} from './homeStyle';

// Deprecated - will be changed when the new unauthenticated homepage
// design will be implemented
import { Arrow, Button } from 'coreOld/components';
import { PartSearch } from 'homeOld/components';

import { buttonsConfig } from 'homeOld/components/Home/config';
import {
  ButtonWrapper,
  ContentWrapper,
  SubTitle,
  Title,
  VersionDecoration,
  VersionTitle,
  VersionWrapper,
  Wrapper,
  buttonStyle,
} from 'homeOld/components/Home/homeStyle';
// END Deprecated

interface IProps {
  control: Control<IAuthForm>;
  user?: IAuthUser;
  accessPlainHomepage?: boolean;
  handleSubmit: UseFormHandleSubmit<IAuthForm>;
  errors: FieldErrors<IAuthForm>;
  onSignIn?: (data: IAuthForm) => void;
}

const HomeView = ({
  control,
  user,
  accessPlainHomepage,
  handleSubmit,
  errors,
  onSignIn,
}: IProps) => {
  const { t } = useTranslation();

  const name = user ? [' ', user?.firstName].join('') : '';

  return (
    <>
      {accessPlainHomepage && (
        <PageGrid container>
          <LeftSide sm={12} md={5}>
            <LogoImage src={PartfinitiLogo} />

            <LeftSideContent>
              <TitleSignIn level={Level.TITLE_MD}>{t('titleSignIn')}</TitleSignIn>

              <FormField
                name="email"
                type={InputType.TEXT_INPUT}
                inputProps={{
                  control,
                  label: t('labelEmail'),
                  size: Size.LG,
                  error: errors?.email,
                  onKeyDown: (event) =>
                    enterPress(
                      event,
                      handleSubmit((data) => onSignIn(data))
                    ),
                  required: true,
                  showFieldError: true,
                }}
              />

              <SsoButton
                text={t('buttonLabelSignInWithSso')}
                variant={Variant.SOLID}
                size={Size.LG}
                startDecorator={<Lock weight="fill" />}
                onClick={handleSubmit((data) => onSignIn(data))}
                fullWidth
              />
            </LeftSideContent>
          </LeftSide>
          <RightSide sm={12} md={7}>
            <Logo>
              <Image src={`${getDomainUrl()}/files/index/display/name/wesco-homepage-logo.svg`} />
            </Logo>
          </RightSide>
        </PageGrid>
      )}

      {!accessPlainHomepage && (
        <Wrapper>
          <ContentWrapper>
            <VersionWrapper>
              <VersionDecoration />

              <VersionTitle>{t('labelVersion')}</VersionTitle>
            </VersionWrapper>

            <Title>{t('messageTrySomethingNew')}</Title>

            <SubTitle>
              <Arrow />

              <Trans
                i18nKey="messageHelloUser"
                values={{ name }}
                components={[<span key="userName" />]}
              />
            </SubTitle>

            <div>
              <PartSearch />

              {buttonsConfig(t).map((config, index) => (
                <ButtonWrapper key={index} to={config.url || '#'} onClick={config.onClick}>
                  <Button style={buttonStyle} fullHeight fullWidth>
                    {config.label}
                  </Button>
                </ButtonWrapper>
              ))}
            </div>
          </ContentWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default HomeView;
